import loadable from '@loadable/component';
import FullPageLoading from '../../../components/Loading/FullPageLoading';
import { THERAPIST_ORGANISATION_LIST_PATH } from '../paths';

export const ORGANISATION_SETTINGS_PATHNAME = `${THERAPIST_ORGANISATION_LIST_PATH}/:orgId`;

export const OrganisationSettingsLoadable = loadable(async () => import('./organisation-settings.view'), {
  fallback: <FullPageLoading />,
});
